import React from 'react'
import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'

type Props = {
  accordionTitle: string
  children?: React.ReactNode
  shoulDisplayAlertIcon?: boolean
  defaultExpanded?: boolean
}

const KAccordion: React.FC<Props> = ({
  accordionTitle,
  children,
  shoulDisplayAlertIcon,
  defaultExpanded,
}) => (
  <Accordion
    // Since when going from list to detail view, RA performs optimistic rendering with the list response record,
    // the default condition will not always be initialized as this component first gets mounted.
    // Thus we need to force its re-render via the key attribute, whenever the default condition changes.
    key={`${defaultExpanded}`}
    style={{ width: '100%' }}
    defaultExpanded={defaultExpanded}
  >
    <AccordionSummary expandIcon={<ExpandMore />}>
      <h2 style={{ marginRight: '.5em' }}>{accordionTitle}</h2>
      {shoulDisplayAlertIcon && (
        <WarningIcon
          color="error"
          style={{ marginTop: 'auto', marginBottom: 'auto' }}
        />
      )}
    </AccordionSummary>
    <AccordionDetails style={{ flexDirection: 'column' }}>
      {children}
    </AccordionDetails>
  </Accordion>
)

export default KAccordion
